import React, { ReactNode, Ref, forwardRef } from 'react';
import { classNames } from 'primereact/utils';
import { normalizeInputValue } from 'utils/text';
import { AutosaveIndicator, AutosaveIndicatorRef } from 'components/_new/AutosaveIndicator';
import { getInputBaseClassName } from '../InputBase';
import './InputText.scss';

export type InputTextProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> & {
	variant?: 'white';
	inline?: boolean;
	search?: boolean;
	value?: string | number | null;
	invalid?: boolean;
	minimal?: boolean;
	slim?: boolean;
	autosaveMessage?: ReactNode;
	autosaveIndicatorRef?: React.Ref<AutosaveIndicatorRef>;
	autosaveIndicatorClassName?: string;
};

export const InputText = forwardRef(
	(
		{
			variant,
			className,
			inline,
			search = false,
			value,
			invalid = false,
			minimal = false,
			slim = false,
			autosaveMessage,
			autosaveIndicatorRef,
			autosaveIndicatorClassName,
			...restProps
		}: InputTextProps,
		ref: Ref<HTMLInputElement>
	) => {
		return (
			<div
				className={classNames('input-text-autosave-wrapper', {
					'input-text-autosave-wrapper-inline': inline,
				})}
			>
				{autosaveMessage && (
					<AutosaveIndicator
						ref={autosaveIndicatorRef}
						absolute
						message={autosaveMessage}
						className={autosaveIndicatorClassName}
					/>
				)}
				<input
					ref={ref}
					type={search ? 'search' : 'text'}
					className={classNames(
						getInputBaseClassName({ inline, slim, minimal, invalid }),
						'input-text',
						{ 'input-color': restProps.type === 'color' },
						className
					)}
					value={normalizeInputValue(value)}
					{...restProps}
				/>
			</div>
		);
	}
);
